"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SpecialLayoutPageTemplate = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Columns = _interopRequireDefault(require("../main/Columns"));

var _Layout = _interopRequireDefault(require("./Layout"));

var SpecialLayoutPageTemplate = function SpecialLayoutPageTemplate(_ref) {
  var contents = _ref.contents,
      langKey = _ref.langKey,
      reusable = _ref.reusable,
      paddingBottom = _ref.paddingBottom;
  return (
    /*#__PURE__*/
    _react["default"].createElement("div", {
      style: {
        paddingBottom: paddingBottom
      }
    }, contents !== null && contents.map(function (content) {
      return (
        /*#__PURE__*/
        _react["default"].createElement(_react["default"].Fragment, null, content.isFullWidth ?
        /*#__PURE__*/
        _react["default"].createElement("div", {
          style: {
            paddingBottom: "1rem"
          }
        },
        /*#__PURE__*/
        _react["default"].createElement(_Columns["default"], {
          content: content,
          langKey: langKey,
          reusable: reusable
        })) :
        /*#__PURE__*/
        _react["default"].createElement("section", {
          className: "section section--gradient",
          style: {
            padding: "2rem 1rem"
          }
        },
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "container",
          style: {
            paddingLeft: "2rem",
            paddingRight: "2rem"
          }
        },
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "columns"
        },
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "column is-12"
        },
        /*#__PURE__*/
        _react["default"].createElement(_Columns["default"], {
          content: content,
          langKey: langKey,
          reusable: reusable
        }))))))
      );
    }))
  );
};

exports.SpecialLayoutPageTemplate = SpecialLayoutPageTemplate;
SpecialLayoutPageTemplate.propTypes = {
  contents: _propTypes["default"].object,
  langKey: _propTypes["default"].string,
  reusable: _propTypes["default"].object,
  paddingBottom: _propTypes["default"].string
};

var SpecialLayoutPage = function SpecialLayoutPage(_ref2) {
  var _ref2$data = _ref2.data,
      _ref2$data$page = _ref2$data.page,
      _ref2$data$page$field = _ref2$data$page.fields,
      langKey = _ref2$data$page$field.langKey,
      pathSlug = _ref2$data$page$field.pathSlug,
      contents = _ref2$data$page.frontmatter.contents,
      reuse = _ref2$data.reusable.edges,
      paddingBottom = _ref2.paddingBottom;
  return (
    /*#__PURE__*/
    _react["default"].createElement(_Layout["default"], {
      langKey: langKey,
      slug: pathSlug
    },
    /*#__PURE__*/
    _react["default"].createElement(SpecialLayoutPageTemplate, {
      contents: contents,
      langKey: langKey,
      reusable: reuse,
      paddingBottom: paddingBottom
    }))
  );
};

SpecialLayoutPage.propTypes = {
  data: _propTypes["default"].shape({
    page: _propTypes["default"].shape({
      frontmatter: _propTypes["default"].object
    }),
    reusable: _propTypes["default"].object
  }),
  paddingBottom: _propTypes["default"].string
};
var _default = SpecialLayoutPage;
exports["default"] = _default;